import React, { useEffect } from "react";

function DeployedToEverywhere(props) {
    useEffect(() => {
        props.SetDeployedToEverywhereLoaded(true)
    }, []);

    return (
        <></>
    )
};

export default DeployedToEverywhere;